import {
  Post, PostFilters, QueryResult,
} from '@/type';
import api from '../API';

export default {

  find(id: number): Promise<Post> {
    return api
      .get(`posts/${id}`)
      .then(response => response.data);
  },
  findAll(filters: PostFilters): Promise<QueryResult> {
    return api
      .get('posts', { params: filters })
      .then(response => response.data);
  },
  count(filters: PostFilters): Promise<number> {
    return api
      .get('posts/count', { params: filters })
      .then(response => response.data.total);
  },
};
